export default "__VITE_ASSET__XS0K$M9V__"